module.exports = __webpack_public_path__ + "static/media/FortCollins_REDUCED.f11bdd6e.jpg";